<div class="goal-container">
    <div class="header">
        <h1>Update Goal</h1>
        <mat-icon (click)="dialogRef.close()" class="close-button" mat-dialog-close>
            clear
        </mat-icon>
    </div>

    <!-- Form Element Here -->
    <app-goal-form 
        (formSubmit)="onConfirmUpdate($event)" 
        (formCancel)="onCancelClick()"
        action="update"
        [existingData]="data"
    >
    </app-goal-form>
    <!-- End of Form Element -->
    
</div>